module.exports = __webpack_public_path__ + "img/suraltsagch.beb12870.svg";